type GetIndexType = {
  barCount: number
  distanceBetweenPeaks: number
  xPosition: number
}

export const getSlopeInterceptIndex = ({
  barCount,
  distanceBetweenPeaks,
  xPosition,
}: GetIndexType): number => {
  const slopeIndex = Math.round(xPosition / distanceBetweenPeaks)
  return slopeIndex < barCount - 1 ? slopeIndex : barCount - 1
}

export const getBarSnapIndex = ({
  barCount,
  distanceBetweenPeaks,
  xPosition,
}: GetIndexType): number => {
  const index = Math.round(xPosition / distanceBetweenPeaks)

  return index > barCount - 1 ? barCount - 1 : index
}

// getBarSnapLocation
export const getBarSnapXPosition = ({
  barCount,
  barWidth,
  index,
  graphWidth,
}: {
  barCount: number
  barWidth: number
  index: number
  graphWidth: number
}): number => {
  const distanceBetweenBars =
    (graphWidth - barWidth * barCount) / (barCount - 1)
  return distanceBetweenBars * index + barWidth * index
}

export const getBarHeight = ({
  slope,
  xPosition,
  yIntercept,
}: {
  slope: number
  xPosition: number
  yIntercept: number
}): number => {
  const barHeight = slope * xPosition + yIntercept
  return barHeight < 8 ? 0 : barHeight - 8
}

export const ANIMATION_VARIANTS = {
  DRAGGING: 'dragging',
  ENTRY: 'entry',
  SNAP: 'snap',
} as const
